import React, { useLayoutEffect, useState } from 'react';
import {connect} from 'react-redux';
import styles from './styles.scss';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import { handleOnChange, handleOnDropdownChange } from '../../customActions';
import Dropdown from 'jd-library/Dropdown';

function UnitboxContainer(props) {
    const [dropdownOptions, setDropdownOptions] = useState([]);
    const {item = {}, parentIndex, handleOnChange, handleOnDropdownChange,isSellOnline} = props;
    const {
        s_type,
        s_id,
        s_dnm,
        s_unit,
        userInput,
        s_mandatory,
        s_re_mandatory,
        s_subType = "",
        s_unit_pos,
        textBoxIsHidden = false
    } = item;
    const isDropdown = s_subType.includes("UnitboxWithDropdown");

    useLayoutEffect(() => {
        if(isDropdown){
            const options = s_unit.reduce((acc, value, index) => {
                acc.push({
                    key: value,
                    label: value
                });
                return acc;
            }, []);
            setDropdownOptions(options);
        }
    }, []);

    let elementOptions = {};
    if(isDropdown){
        elementOptions = {
            className: `${styles["dropdown-div"]} ${userInput?.textboxError ? styles['dropdown-error'] : ""}`,
            optionList: dropdownOptions,
            activeClass: styles["dropdown-div-input-active"],
            onChange: (e, selectedIndex) => {
                handleOnDropdownChange({value: e.label || "", item, parentIndex, key:"textboxValue"});
            },
            placeholder: ['net_quantity', 'net_weight'].includes(item.s_nm) ? 'Select Units' : s_dnm,
            value: userInput?.textboxValue,
            disabled: props?.isEnrichSpec ? true : false
        } ;
    }

    let rightSelection = {}
    if(!isDropdown){
        rightSelection = {
            rightSectionClass : styles["unit-text"],
            rightSection : () => {
                return s_unit.toString()
            }
        }
    }

    return !textBoxIsHidden &&  (
        <div className={`${styles["unitbox-wrapper"]} ${styles["unitbox-container"]}`}>
            <div className={`${styles["unitbox-input-container"]} ${isDropdown ?  styles["unitboxWithDropdown"] : ""} ${!isDropdown && (Number(s_unit_pos) ? styles["unit-prepend"] : styles["unit-append"])}`}>
                <div className={styles['unitbox-textbox']}>
                    <InputWithMovingLabel
                        key = { `${s_type}-${s_id}-${parentIndex}` }
                        as = { s_type.toLowerCase()  }
                        label = { s_dnm || "" }
                        input={{
                            value :  userInput.value || "",
                            type :  'text',
                            name :  s_dnm,
                            autoFocus : false,
                            autoComplete :  "off",
                            onChange :  (e) => handleOnChange({e, parentIndex, item,isSellOnline}),
                            onBlur :  () => {},
                            readOnly: (props?.isEnrichSpec && userInput.value) ? true : false,
                            onFocus : (e) => e.target.value && handleOnChange({e, parentIndex, item,isSellOnline})
                        }}
                        labelOnTop={!isDropdown}
                        holderClass = {  "specification-input-holder" }
                        errorMessage = { userInput.error }
                        errClass = {'unitbox-input-container-errClass'}
                        infoMessage={!userInput.error && (props.showSellOnline || props.isService ? s_mandatory =='1' : s_re_mandatory == '1') && !props.isAuditor && !props.session.viaOmni ? 'Required Field':''}
                        {...rightSelection}
                    />
                </div>
                {
                    isDropdown && (
                        <div>
                            <Dropdown {...elementOptions} />
                            { userInput.textboxError && <span className={styles["unit-box-error-message"]}>{userInput.textboxError}</span> || null}
                        </div>
                    )


                }
            </div>
        </div>
    ) || null;
}

const mapStateToProps = (state, props) => {
    return {
        ...props,
        item: state.productSpecification.editablePuvSpecAttributes[props.parentIndex],
        isSellOnline: state.products.editProduct.isSellOnline || props.showSellOnline,
        session: state.session,
        isService:  state.products.editProduct.categoryType == 'service',
        isAuditor: state.session?.user?.loggedUser?.userType == "AUDITOR"
    }
}

const mapDispatchToProps = dispatch => {
    return {
        handleOnChange : payload => dispatch(handleOnChange(payload)),
        handleOnDropdownChange: payload => handleOnDropdownChange(payload, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UnitboxContainer)
